<template>
    <footer>
        <div id="footer">
            <dl> 
                <dt>最新参考</dt> 
                <dd>世界金属价格</dd> 
                <dd>世界汇率</dd> 
                <dd>新币发行</dd> 
            </dl> 
            <dl> 
                <dt>学习更多</dt> 
                <dd><a href="/aboutGrade" target="_blank">有关硬币品相等级的概述</a></dd> 
                <dd><a href="/historyOfRMB" target="_blank">人民币硬币发展史</a></dd> 
                <dd><a href="/historyOfHKDollar" target="_blank">香港硬币发展概述</a></dd> 
                <dd><a href="/majorMints" target="_blank">世界铸币厂的厂记概述</a></dd> 
                <dd><a href="/guideOfCoins" target="_blank">钱币保存指南</a></dd> 
                <dd><a href="/worldWebSite" target="_blank">世界各国铸币厂及其网址</a></dd> 
            </dl> 
            <div id="friends">友情链接：<a href="http://www.zcxn.com/" target="_blank">中国收藏家协会</a><a href="http://www.qbwjs.com/" target="_blank">中国钱币网</a>   《收藏家》杂志 <br />
                <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2022146162号-1</a></div>
            <div style="clear:both;"></div>
            
        </div>
    </footer>

</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style scoped>
    footer{min-width:100%;background-color:#2F2F2F;color: #FFFFFF; margin-top: 40px; line-height:200%; padding-top: 30px;padding-bottom: 30px; font-size: 14px;}
    #footer{width: 900px; margin: 0 auto; text-align: left;}
    #footer a{margin-right: 10px; text-decoration: none;color: #FFFFFF;}
    #footer a:hover{text-decoration: underline;}
    #footer dl{width: 240px;float: left; height: 100%; overflow: hidden;}
    #footer dl dt{font-weight: bold;font-size: 14px;;}
    /* #friends{width: 100%; text-align: center;} */
    #friends{ text-align: center; float:right;}
</style>
